import script from "./ModalCrearEvento.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalCrearEvento.vue?vue&type=script&setup=true&lang=js"

import "./ModalCrearEvento.vue?vue&type=style&index=0&id=a7ed2422&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7ed2422"]])

export default __exports__